module.exports = __webpack_public_path__ + "static/img/medal2.b9c47c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/1/medal2.png
// module id = h8AM
// module chunks = 1